import ArchiveListPageStore from './ArchiveListPageStore'

export default ArchiveListPageStore
